import { useEffect } from 'react';
import { authApi } from '@/core/api/authApi';
import { queryClient } from '@/core/query/queryClient';
import { useAuthStore } from './authStore';

export const useAuthBootstrap = (): void => {
  const status = useAuthStore((state) => state.status);
  const accessToken = useAuthStore((state) => state.accessToken);
  const refreshToken = useAuthStore((state) => state.refreshToken);
  const setStatus = useAuthStore((state) => state.setStatus);
  const setBootstrapData = useAuthStore((state) => state.setBootstrapData);
  const clearSession = useAuthStore((state) => state.clearSession);

  useEffect(() => {
    if (status !== 'idle') return;
    if (!accessToken || !refreshToken) {
      clearSession();
      return;
    }

    setStatus('bootstrapping');
    authApi
      .bootstrap()
      .then((data) => {
        setBootstrapData(data);
      })
      .catch(() => {
        queryClient.clear();
        clearSession();
      });
  }, [accessToken, clearSession, refreshToken, setBootstrapData, setStatus, status]);
};
